export default __webpack_public_path__ + "static/media/G_D_btn___gallery_prev.d6294eb7.svg";